// 日语
module.exports = {
    public: {
        confirm: '確認',
        cancel: '取消',
        reset: 'リセット',
        search: '検索',
        RefreshSucceeded: '更新成功',
        noMoreData: 'データなし',
        pullingText: '更新するには下に引っ張る…',
        ReleaseText: 'リリースで更新…',
        loadingText: 'ロード中…',
        noData: '記録なし',
        copyTxt: 'コピー',
        copySuccess: 'コピー成功',
        amount: '金額',
        buy: '購入',
        orderNo: '注文番号',
        selectLang: '言語選択',
        light: 'ライト',
        dark: 'ダーク',
        All: 'すべて',
        DigitalCurrency: '仮想通貨',
        foreignExchange: '外国為替',
        futures: '先物',
        stockIndex: '株価指数',
        stock: '株式',
        BalanceNot: '残高不足',
        optional: 'お気に入り',
        market: '相場',
        USDTcontract: 'USDT契約',
        Fiatcurrencycontract: '法定通貨契約',
        spot: '現物',
        secondContract: '秒契約',
        emptyTxt: '記録がありません',
    },
    tabBar: {
        home: 'ホーム',
        market: '発見',
        trade: '取引',
        heel: '理財です',
        asset: '資産',
    },
    about: {
        title: '私たちについて',
        version: 'バージョン',
        about: '詳細',
        ProductIntroduction: '製品紹介',
        Termofservice: '利用規約',
        PrivacyAgreement: 'プライバシー同意書',
        Riskstatement: 'リスク提示',
        whitePaper: 'ホワイトペーパー',
    },
    asset: {
        Overview: '概要',
        contract: '契約',
        wallet: 'ウォレット',
        Totalassetvaluation: '総資産評価',
        supportswithdrawal: '入金した資産は引き出し可能',
        Recharge: '入金',
        Contractaccount: '契約口座',
        Spotaccount: '現物口座',
        Walletaccount: 'ウォレット口座',
        ValuationContractAssets: '契約資産評価',
        profitloss: '損益',
        Transfer: '振替',
        occupy: 'ロック＃ロック＃',
        available: '利用可能',
        Viewallpositions: '全ポジション表示',
        Valuationspotassets: '現物資産評価',
        Hidezerobalanceassets: 'ゼロ残高資産を非表示',
        balance: '残高',
        ValuationWalletAssets: 'ウォレット資産評価',
        Withdrawal: '引き出し',
        Walletbalance: 'ウォレット残高',
        Cryptocurrencyrecharge: '仮想通貨入金',
        Fiatcurrencyrecharge: '法定通貨入金',
        From: 'から',
        To: 'へ',
        UsdtContractaccount: 'USDT契約口座',
        FiatContractaccount: '法定通貨契約口座',
        Currency: '通貨',
        quantity: '数量',
        availablebalance: '利用可能残高',
        Insufficientavailablebalance: '利用可能残高不足',
        Transfersuccessful: '振替成功',
        flashcash: 'フラッシュ交換',
        flashcashsuccessful: 'フラッシュ交換成功',
    },
    auth: {
        title: '本人確認',
        gj: '国籍',
        tipsgj: '国籍を選択',
        userName: '氏名',
        tips1: '氏名を入力',
        IDNumber: 'ID番号',
        tips2: 'ID番号を入力',
        base: '初級認証',
        high: '上級認証',
        zmz: 'ID表写真',
        bmz: 'ID裏写真',
        tips3: 'ID表写真をアップロード',
        tips4: 'ID裏写真をアップロード',
        btn: '提出',
        upbtn: 'ID変更',
        subMsg: '提出成功、審査待ち',
        upMsg: '変更後再審査、変更しますか？',
        wait: '審査中',
        fail: '認証失敗',
        success: '認証成功',
        cardType: 'ID種類',
        idCard: '身分証',
        passport: 'パスポート',
        driverlicense: '運転免許証',
        AssetCertification: '資産認証',
        AccountType: '口座タイプ',
        holdingamount: '保有金額',
        Accountscreenshot: '口座スクリーンショット',
        bankaccount: '銀行口座',
        IRAaccount: 'IRA口座',
        stockaccount: '株式口座',
        other: 'その他',
        AccountTypetips: '口座タイプを選択してください',
        Accountscreenshottips: '口座のスクリーンショットをアップロードしてください',
    },
    activity: {
        toptit: '福利厚生',
        inviteTxt: '友達を1人招待するごとに{amount} USDを獲得、最大で3階層のコミッションに対応',
        invitebtn: '招待して報酬を得る',
        rechargeTxt: 'あなたの下位ユーザーが入金すると、{amount}%のコミッションを獲得、最大で3階層のコミッションに対応',
        rechargebtn: '入金報酬',
        authTxt: '本人確認に成功すると{amount} USDをプレゼント',
        authbtn: '本人確認',
        inviteRewardTxt: '<p><strong>友達を招待して、簡単に30 USDをゲット</strong></p><p><br></p><p>一、キャンペーン目的</p><p><br></p><p>対象ユーザー：新規および既存ユーザーが参加可能で、既存ユーザーに友達を積極的に招待して登録し、指定の操作を完了してもらい、プラットフォームのユーザーベースを拡大することを促進します。</p><p>主要要望：紹介制度を通じて新規ユーザーの迅速な流入と拡散的成長を促し、同時に招待者に実質的な報酬を与え、ユーザーの定着率と忠誠心を高めます。</p><p><br></p><p>二、キャンペーン期間</p><p><br></p><p>2023年5月20日～長期有効（定期的に確認または終了の場合は別途告知）</p><p><br></p><p>三、参加対象</p><p><br></p><p>プラットフォーム登録済みで基礎本人確認を完了したユーザーは招待者（A）となれます；</p><p>招待された人（B）は招待リンクまたは招待コードを使って新規登録し、本人確認を完了した場合に有効となります。</p><p><br></p><p>四、参加ルール</p><p><br></p><p>招待方法</p><p>招待者（A）は「マイページ」→「友達を招待」→専用の招待リンク／招待コードをコピーします。</p><p>リンク／招待コードを友達（B）に共有し、ウェブまたはアプリで登録してもらいます。</p><p><br></p><p>招待された人の要件</p><p>招待された人（B）は招待者のリンクまたはコードを使用して初回登録を完了しなければなりません。</p><p>登録後7日以内に本人確認を完了し、最低入金基準（例：初回入金1000 USD以上または同等のトークン）を満たす必要があります。</p><p><br></p><p>階層区分</p><p>本キャンペーンは最大3階層の紹介報酬に対応しています。</p><p>第一層（直接紹介）：Aが直接Bを招待し登録させます。</p><p>第二層：BがCを招待し、Aは二層目の報酬を獲得します。</p><p>第三層：CがDを招待し、Aは三層目の報酬を獲得します。</p><p>三層目以降（DがEを招待する等）はAの報酬対象外です。</p><p><br></p><p>五、報酬詳細</p><p><br></p><p>一層目招待報酬（直接紹介）</p><p>招待されたBが入金かつ本人確認を完了した後、招待者Aは30 USDを獲得します。</p><p><br></p><p>二層目招待報酬（間接紹介）</p><p>Bが招待者となり直接招待したCが同条件（本人確認＋最低入金）を満たした場合、Aは15 USDを獲得します。</p><p><br></p><p>三層目招待報酬（再間接紹介）</p><p>CがDを招待し条件を満たした場合、Aは10 USDを獲得します。</p><p><br></p><p>報酬付与方法</p><p>システムが3階層の招待関係を自動認識し、下位（直接・間接）ユーザーが条件を満たした際、<strong>48時間以内</strong>に該当報酬を招待者Aのアカウント資産に自動付与します。</p><p><br></p><p><br></p><p>六、操作例</p><p><br></p><p>Aはcryptorixにログインし、「マイページ」→「友達を招待」→専用の招待リンク／招待コードをコピーします。</p><p>Aはリンク／コードを友達Bに送ります。</p><p>Bはリンクをクリックまたはコードを入力し、登録ページへ遷移→メール登録→本人確認完了かつ1000 USD以上入金。</p><p>Bが本人確認と入金完了後、オンラインサポートに報酬申請が可能となり、審査通過後48時間以内に30 USDがAに自動付与されます。</p><p>BがCを招待し、Cも条件を満たせば、システムは15 USDをAに自動付与します。さらにCがDを招待しDが条件を満たすと、システムは10 USDをAに自動付与します。</p><p><br></p><p>&nbsp;</p><p>七、リスク管理と注意事項</p><p><br></p><p>不正報酬防止策</p><p>同一の電話番号／メールアドレスは一度のみ招待可能で、同一IPや本人確認情報など複数の項目で連動検査が行われます。</p><p>同一デバイスやネットワーク環境からの大量かつ質の低い登録行為は管理者による審査対象となり、必要に応じて報酬が取り消されます。</p><p><br></p><p>違反処分</p><p>悪意ある報酬不正取得や現金化行為が判明した場合、プラットフォームは関連する報酬をすべて取り消し、アカウントを凍結する権利を有します。</p><p><br></p><p>&nbsp;</p>',
        rechargeRewardTxt: '<p><strong>下位ユーザーの入金報酬で、待ち時間なしで収益獲得</strong></p><p><br></p><p><strong>一、キャンペーン目的</strong></p><p><br></p><p>対象ユーザー：本人確認を完了した一層目招待者（A）は、その下位ユーザー（B、C、D）がプラットフォームで入金操作を行った際、プラットフォームが設定した割合の報酬を得られ、「拡散チェーン」の育成とユーザー活性化を目指します。</p><p><br></p><p>主要要望：「入金報酬」メカニズムにより、新規ユーザーの入金行為と招待者の利益を結びつけ、「招待－入金－報酬－再招待」の好循環を形成し、プラットフォームの資金定着と活性化を促進します。</p><p><br></p><p><strong>二、キャンペーン期間</strong></p><p><br></p><p>常時開催：2023年5月20日より長期有効。業務上の必要に応じて報酬率や終了時期は予告の上で変更可能。</p><p><br></p><p><strong>三、参加対象</strong></p><p><br></p><p>招待者A：本人確認済みのユーザーで、少なくとも1名の下位ユーザーが本人確認を完了していること（B）。</p><p><br></p><p>下位ユーザーB、C、D：Aに招待されたか、その下位により招待された第2、第3階層のユーザーで、下位がプラットフォームで入金するとAは報酬を得ます。</p><p><br></p><p><strong>四、参加ルール</strong></p><p><br></p><p><strong>階層関係：</strong></p><p><br></p><p>第一層（直接招待B）：Bが入金（法定通貨または他トークンで最低入金額を満たす）した場合、システムは入金額の1%（下記報酬ルール参照）をAに報酬として支払います。</p><p>第二層（BがCを招待）：Cが入金した場合、AはCの入金額の0.5%を報酬として得ます。</p><p>第三層（CがDを招待）：Dが入金した場合、AはDの入金額の0.3%を報酬として得ます（割合は低くなります）。</p><p>3階層のみの報酬対応で、それ以上の階層の入金はAへの報酬対象外です。</p><p><br></p><p><strong>入金経路と最低額：</strong></p><p><br></p><p>プラットフォームで対応する全ての入金経路（法定通貨または複数ネットワークの暗号資産入金）をサポートしますが、単一入金は1000 USD相当以上でなければ報酬計算に含まれません。</p><p><br></p><p><strong>報酬率</strong></p><p><br></p><p>一層B 1.0% 例：Bが1000 USD入金した場合、Aは10 USDを得ます</p><p>  </p><p>二層C 0.5% 例：Cが1000 USD入金した場合、Aは5 USDを得ます</p><p><br></p><p>三層D 0.3% 例：Dが1000 USD入金した場合、Aは3 USDを得ます</p><p><br></p><p><strong>報酬付与方法</strong></p><p><br></p><p>下位ユーザーの入金が完了し資金が反映された24時間以内に、対応報酬が招待者Aの取引アカウントに自動付与されます；</p><p>ユーザーは「マイウォレット」→「報酬明細」で各報酬の発生源、金額、付与時間を確認可能です。</p><p><br></p><p><strong>五、操作例</strong></p><p><br></p><p>Aはアプリにログイン→「マイページ」→「友達を招待」→専用招待リンク／コードをコピーします。</p><p>Aは推薦リンク／コードをBに提供します。</p><p>Bは新規登録→本人確認完了→入金（最低1000 USD）。</p><p>入金完了後、システムが自動計算：B入金総額×1%=Aの報酬。24時間以内に報酬はAのキャンペーンアカウントへ入金されます。</p><p><br></p><p>Bは招待者となりCを招待可能。Cが入金すると、システムはBとAの2階層分報酬を自動計算します：</p><p>BはCの入金×1%を獲得；</p><p>AはCの入金×0.5%を獲得。</p><p><br></p><p>CはDを招待可能。Dが入金すると、3階層分報酬が発生します：</p><p>CはDの入金×1%を獲得；</p><p>BはDの入金×0.5%を獲得；</p><p>AはDの入金×0.3%を獲得。</p><p><br></p><p><strong>六、リスク管理と注意事項</strong></p><p><br></p><p><strong>悪意ある不正防止</strong></p><p><br></p><p>同一ユーザーが自身のアカウントで循環入金を行うことはできません；異常な少額の複数入金や短期間の大額入金および出金はログとリスク管理で検知し、必要に応じて人工審査や報酬取り消しを行います。</p><p>入金後すぐにキャンセルし頻繁な操作を繰り返すユーザーは悪意のある不正行為とみなされ、報酬が取消されます。</p><p><br></p><p><strong>コンプライアンス審査</strong></p><p><br></p><p>システムまたは管理画面のリスク管理が招待されたユーザーにマネーロンダリングや現金化リスクを検知した場合、プラットフォームは該当ユーザーおよび関連チェーンのすべての報酬を凍結し、監督機関への報告権利を保持します。</p><p><br></p><p><br></p>',
        authRewardTxt: '<p><strong>本人確認完了で50 USDプレゼント</strong></p><p><br></p><p>一、キャンペーン目的</p><p><br></p><p>対象ユーザー：プラットフォームの新規登録ユーザーおよび既存ユーザー（過去に本人確認を完了していない場合）も参加可能で、新規ユーザーの本人確認完了促進と定着を主な目的とし、本人確認が面倒で躊躇しているユーザーの早期認証を促します。</p><p>主要要望：現金報酬の付与によりユーザーの本人確認完了を促進し、リスク管理品質とKYCカバレッジを向上させ、プラットフォームのコンプライアンス運営を保証します。</p><p><br></p><p>二、キャンペーン期間</p><p><br></p><p>2023年5月20日～長期有効</p><p><br></p><p>三、参加対象</p><p><br></p><p>新規ユーザー：cryptorixプラットフォームに初めて登録し、キャンペーン期間中に本人確認を完了したユーザー。</p><p>既存ユーザー：キャンペーン開始前に登録済みでまだ本人確認を完了していないユーザーは期間内に本人確認を完了することで報酬を得られます。</p><p><br></p><p>四、参加ルール</p><p><br></p><p>本人確認要件</p><p>ユーザーは鮮明な身分証明書（IDカード／パスポート／運転免許証など）の表裏写真と本人が身分証を持っている半身写真をアップロードする必要があります；</p><p>顔認証は十分な照明と顔の遮蔽なしで行い、プラットフォームのライブネス検証要件を満たす必要があります；</p><p>提出後の審査は通常24時間以内に完了します。</p><p><br></p><p>報酬額</p><p>キャンペーン期間中に本人確認を完了した全ユーザー（新旧ユーザー両方）が50 USDを受け取れます。</p><p><br></p><p>受け取り方法と付与時間</p><p>本人確認完了後、システムは24時間以内に50 USDを法定通貨契約アカウントに入金します；10回の正常な取引完了後に出金可能となります。</p><p><br></p><p>不備や審査未通過の場合、ユーザーはシステムの指示に従い資料を追加提出し、審査通過後に報酬を受け取れます。</p><p><br></p><p>五、操作例</p><p><br></p><p>ユーザーはアプリにログインし、「本人確認」→本人確認手続きを開始します。</p><p>身分証明書／パスポート／運転免許証の表裏写真をアップロードします。</p><p>システムが自動で情報照合し、不合格の場合は再撮影を促します。</p><p>審査合格後、24時間以内に50 USDの報酬が「法定通貨契約アカウント」に付与されます。</p><p><br></p><p>六、リスク管理と注意事項</p><p><br></p><p>不正報酬防止</p><p>同一身分証明書での報酬受取は一回限りです；同一IPや同一端末番号で複数証明書申請はシステムがリスク制限をかけ、人工審査または直接拒否されます。</p><p>明らかに偽造、改ざん、画像加工された証明書は発見次第、報酬は取り消されます。</p><p><br></p><p>違反処分</p><p>悪意ある不正取得や現金化行為が判明した場合、プラットフォームは関連する報酬をすべて取り消し、アカウントを凍結する権利を有します。</p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: '資金明細',
        audit: '審査待ち',
        success: '成功',
        refuse: '拒否',
        recharge: '入金',
        recharge_currency: '仮想通貨入金',
        recharge_legal: '法定通貨入金',
        withdrawal: '引き出し',
        withdrawal_currency: '仮想通貨引き出し',
        cancel_withdrawal_currency: '仮想通貨引き出しキャンセル',
        withdrawal_legal: '法定通貨引き出し',
        cancel_withdrawal_legal: '法定通貨引き出しキャンセル',
        transfer: '振替',
        usdt_contract_wallet: 'USDT契約→ウォレット',
        legal_contract_wallet: '法定通貨契約→ウォレット',
        coin_currency_wallet: '現物→ウォレット',
        wallet_usdt_contract: 'ウォレット→USDT契約',
        wallet_legal_contract: 'ウォレット→法定通貨契約',
        wallet_coin_currency: 'ウォレット→現物',
        finance_wallet: '理財です→ウォレット',
        wallet_finance: 'ウォレット→理財です',
        usdt_contract_currency: 'USDT契約 → 現物',
        finance_currency: 'ファイナンス → 現物',
        currency_usdt_contract: '現物 → USDT契約',
        currency_finance: '現物 → ファイナンス',
        legal_contract_currency: '法定通貨契約 → 現物',
        currency_legal_contract: '現物 → 法定通貨契約',
        recharge_reward: '下位ユーザーの入金によるコミッション',
        auth_reward: '本人確認報酬',
        flashcash: 'フラッシュ交換',
        trade: '取引',
        create_order: '注文',
        settlement_order: '注文決済',
        cancel_order: '注文キャンセル',
        finance_return: '元本返還',
        finance_income: '投資収益',
        other: 'その他',
        commission_transfer: '手数料振替',
        platform_gift: 'プラットフォーム贈呈',
        system_regulation: '残高の変更',
        freeze_thaw: '凍結解凍',
        c2c_create_order: 'C2C注文',
        c2c_cancel_order: 'C2C注文キャンセル',
        Currency: '通貨',
        type: '種類',
        SelectCurrency: '通貨選択',
        SelectType: '種類選択',
        SelectDate: '日付選択',
        to: 'まで',
        Contractfunds: '契約資金',
        Spotfunds: '現物資金',
        Walletfunds: 'ウォレット資金',
        RechargeRecord: '入金記録',
        WithdrawalRecord: '引き出し記録',
        virtualcoin: '仮想通貨',
        Legaltender: '法定通貨',
    },
    c2c: {
        limit: '限度額',
        available: '利用可能',
        price: '単価',
        needpay: 'お支払い金額',
        willreceive: '受け取る金額',
        Insufficientlimit: '限度額不足',
        Exceedinglimit: '限度額超過',
        Exceedingavailable: '利用可能額超過',
        balance: '残高',
        InsufficientBalance: '残高不足',
        OrderHistory: '注文履歴',
        quantity: '数量',
        amountmoney: '金額',
        OrderNo: '注文番号',
        inprogress: '進行中',
        Completed: '完了',
        Cancelled: 'キャンセル済み',
        all: 'すべて',
        chat: 'チャット',
        picture: '[画像]',
        Read: '既読',
        Unread: '未読',
        inputTips: 'ここにメッセージを入力してください',
        send: '送信',
    },
    common: {
        title: '全機能',
        Depositcoins: '仮想通貨入金',
        Rechargefiatcurrency: '法定通貨入金',
        Withdraw: '引き出し',
        documentation: 'コピー取引',
        Activecenter: 'イベントセンター',
        Invitationforrebate: '招待リベート',
        Detailsoffunds: '資金明細',
        Positiondetails: 'ポジション明細',
        Notice: '情報',
        Aboutus: '私たちについて',
        helpcenter: 'ヘルプセンター',
        customer: 'カスタマーサポート',
        Cryptocurrencywithdrawal: '仮想通貨引き出し',
        Fiatmoneywithdrawal: '法定通貨引き出し',
        DepositcoinsTips: 'シンプルな手順で素早くコインを購入',
        RechargefiatcurrencyTips: '法定通貨チャネルを通じてUSDをチャージ',
        USDTcontractTips: 'USDT決済の多様な契約',
        FiatcurrencycontractTips: '法定通貨決済の多様な契約',
        TransferTips: 'ワンタッチで異なる暗号化通貨資産に変換',
        c2cTips: '柔軟な支払い方式で取引手数料ゼロで暗号通貨を売買します',
    },
    forgotPass: {
        title: 'パスワードリセット',
        btn: '確認',
        Password: '新パスワード',
        placeholder: '新パスワードを入力',
        success: '設定成功',
    },
    finance: {
        financeAssetAmount: '金融資産評価額',
        financeAccount: '金融口座',
        financefund: '金融資金',
        financeProduct: '金融商品',
        Applynow: '今すぐ申し込む',
        term: '期間',
        investment: '投資金額',
        Mininvestment: '最低投資額',
        Maxinvestment: '最大投資額',
        buyNum: '購入回数',
        Myincome: '私の収益',
        Dailyearnings: '日次収益',
        yieldmaturity: '満期収益',
        timeaxis: 'タイムライン',
        Subscriptiondate: '申込日',
        valuedate: '利息開始日',
        duedate: '満期日',
        Receiptdate: '受取日',
        day: '日',
        financeOrderList: '金融履歴',
        interestrate: '利率',
        Revenueamount: '収益額',
        Settlementamount: '決済金額',
        regularly: '定期',
        eecurrent: '普通',
        redemption: '償還',
        redemptionTips: 'この金融商品を償還することを確認してください',
        loan: 'ローン',
        LoanRange: '借入範囲',
        LoanAmount: '借入金額',
        loanTerm: '借入期間',
        Dailyinterestrate: '日利率',
        Totalinterest: '利息合計',
        Repaymentmethod: '返済方法',
        Repaymentofmaturity: '満期一括元利返済',
        Estimatedreturn: '返済予定額',
        Ihavereadandagree: '私は読んで同意しました',
        LoanAgreement: '借入契約',
        Immediatelymoney: '今すぐ借りる',
        Minimumloanamount: '最低借入金額',
        Maximumloanamount: '最高借入金額',
        Applicationsuccessfulreview: '申請が成功しました。システム審査をお待ちください',
        Loanrecords: 'ローン記録',
        Pendingreview: '審査待ち',
        issued: '支給済み',
        Repaid: '返済済み',
        Rejected: '却下',
        LoanDate: '借入日',
        AmountDue: '支払予定額',
        repayment: '返済',
        loanTTips: '迅速に入金、複数の質押期間を選択可能',
        homeAddress: '詳細な自宅住所',
        homeAddressTips: '詳細な自宅住所を入力してください',
        emergencyContact: '緊急連絡先',
        emergencyContactTips: '緊急連絡先を入力してください',
        emergencyPhone: '緊急連絡先の携帯番号',
        emergencyPhoneTips: '緊急連絡先の携帯番号を入力してください',
        emergencyEmail: '緊急連絡先のメール',
        emergencyEmailTips: '緊急連絡先のメールを入力してください',
        isHouse: '自分名義の不動産を所有していますか',
        houseImg: '不動産がある場合は所有証明の画像を提供してください',
        certImg: '証明書の表面 (身分証/パスポート/運転免許証)',
        certImgTips: '証明書の表面をアップロードしてください (身分証/パスポート/運転免許証)',
        certBackImg: '証明書の裏面 (身分証/パスポート/運転免許証)',
        certBackImgTips: '証明書の裏面をアップロードしてください (身分証/パスポート/運転免許証)',
        trustImg: '信用スコアのスクリーンショット',
        trustImgTips: '信用スコアのスクリーンショットをアップロードしてください',
        yesTxt: 'はい',
        noTxt: 'いいえ',
        EstimatedReturn: '予想収益',
        seeDetail: '詳細を見る',
        orderDetails: '注文詳細',
    },
    heel: {
        tips: '近日公開予定～',
    },
    home: {
        optional: 'オプション',
        HotList: '人気ランキング',
        more: 'もっと見る',
        Capturetrading: '取引チャンスを捉える',
        Exploreproducts: '当社の製品を探る',
        Contracttrading: '契約取引',
        Spottrading: '理財です',
        ContracttradingTips: '人気の高いレバレッジ派生商品、最大100倍のレバレッジ対応。ロング・ショート両方の取引が可能、市場の変動があれば利益のチャンス。',
        SpottradingTips: '最小限のコストで最大の利益。いつでもどこでも取引開始。',
        starttrading: '取引開始',
        Tradeanytime: 'いつでもどこでも取引',
        Scandownload: 'スキャンしてダウンロード',
        hundredmillion: '億',
        thousand: '万',
        year: '年',
        transactionvolume: '24時間取引量',
        openinterest: '24時間建玉',
        RegisteredUser: '登録ユーザー',
        Ensuresafetyfunds: '資金の安全を確保',
        Reasonschoosingus: '私たちを選ぶ理由',
        mobeginwith: '設立',
        Topliquidity: 'トップクラスの流動性',
        Effectivelyusers: 'ユーザーの権利を効果的に保護',
        TradeNow: '今すぐ取引',
        Needhelp: 'サポートが必要ですか',
        helpcenter: 'ヘルプセンター',
        helpcenterTips: 'よくある質問への対応や、特定機能の詳細説明を提供。',
        Learnmore: '詳細を見る',
        Onlinecustomerservice: 'オンラインカスタマーサービス',
        OnlinecustomerserviceTips: '24時間365日カスタマーサポートを提供、いつでもどこでも対応可能。',
        PlatformAnnouncement: 'プラットフォームのお知らせ',
        PlatformAnnouncementTips: '最新情報を提供し、リアルタイムで取引情報を把握。',
        Starttradingnow: '今すぐ暗号資産取引を始めよう！',
        Trademillions: '何百万人ものユーザーが信頼するプラットフォームで取引',
        Storingbuyingcoins: 'チャージまたはコイン購入',
        product: '製品',
        service: 'サービス',
        guide: 'ガイド',
        agreedannouncement: '利用規約と声明',
        customerservice: 'カスタマーサービス',
        Riskstatement: 'リスクに関する声明: デジタル資産取引は新興産業であり、大きな可能性を秘めていますが、新しい分野であるため高いリスクも伴います。特にレバレッジ取引では、レバレッジ倍率が利益だけでなくリスクも同時に拡大させます。そのため、この業界、レバレッジ取引の仕組み、取引ルールについて十分に理解した上で参加してください。また、ご自身が負担できるリスクの範囲内で取引することを強くお勧めします。取引にはリスクが伴うため、慎重にご判断ください。',
        topTips: '可能性は無限です',
        coin: '現物取引',
        coinTips: '即時で透明、いつでもどこでも現物取引の旅を始めましょう',
    },
    login: {
        title: 'ログイン',
        Account: 'ログインID',
        Password: 'パスワード',
        btn: 'ログイン',
        placeholder: '電話番号を入力',
        placeholder1: 'パスワードを入力',
        ForgotPassword: 'パスワード忘れ',
        noAccount: 'アカウントなし？',
        Registration: '登録',
        server: 'カスタマーサポート',
        success: 'ログイン成功',
        checkedAgree: 'プライバシー同意書に同意してください',
        rememberpassword: 'パスワードを記憶',
        agreewith: '同意する',
        PrivacyAgreement: 'プライバシー同意書',
    },
    market: {
        product: '商品',
        Latestprice: '最新価格',
        volume: '取引量',
        ChangeRatio: '変動率',
        Addoptional: 'お気に入り追加',
        optional: 'お気に入り',
        market: '相場',
        Editselfselection: 'お気に入り編集',
        operate: '操作',
        SelectAll: '全選択',
        delete: '削除',
        time: '時間',
    },
    position: {
        title: 'ポジション明細',
        totalassets: '総資産',
        profitloss: '損益',
        Holdingassets: '保有資産',
        margin: '証拠金',
        orderAmount: '注文金額',
        availableassets: '利用可能資産',
        product: '商品',
        direction: '方向',
        Entrustedprice: '委託価格',
        Entrustednum: '委託数量',
        Currentprice: '現在価格',
        Stoplossprice: '損切り価格',
        stopSurplusPrice: '利確価格',
        Leverageratio: 'レバレッジ',
        Entrustedtime: '委託時間',
        orderno: '注文番号',
        marketvalue: '時価総額',
        SettlementPrice: '決済価格',
        Settlementtime: '決済時間',
        Settakeprofitloss: '利確損切り設定',
        closeposition: 'ポジション決済',
        Position: '現在の委託',
        commission: '過去の委託',
        Settlement: '過去の決済',
        Settingsuccessful: '設定成功',
        Confirmclosingorder: '注文決済を確認',
        Closingsuccessfully: '決済成功',
        cancelorder: '注文キャンセルを確認',
        Cancelsuccessfully: 'キャンセル成功',
        status: '状態',
        changeRate: '手数料',
    },
    property: {
        title: '資産明細',
        totalassets: '総資産',
        profitloss: '損益',
        Holdingassets: '保有資産',
        margin: '証拠金',
        availableassets: '利用可能資産',
        investmentportfolio: '投資ポートフォリオ',
        Recentincomesituation: '最近の収益状況',
        Seemore: 'もっと見る',
        IncomeDetails: '収益明細',
    },
    recharge: {
        mixAmount: '最小入金額',
        subMsg: '提出成功、審査待ち',
        amountMsg: '金額を入力',
        VoucherMsg: '支払い証明をアップロード',
        Depositcoins: '仮想通貨入金',
        Rechargecurrency: '入金通貨',
        RechargecurrencyTips: '200USDT以上で即時入金',
        Depositaddress: '入金アドレス',
        Rechargetoaccount: '入金完了',
        Walletaccount: 'ウォレット口座',
        Rechargequantity: '入金数量',
        Paymentvoucher: '支払い証明',
        Youneedtorecharge: '入金必要額',
        Rechargenow: '今すぐ入金',
        Rechargefiatcurrency: '法定通貨入金',
        Topupfiatcurrency: '法定通貨入金',
        paymentcurrency: '支払い通貨',
        paymentcurrencyTips: '200USD以上で即時入金',
        Fiatcontractaccount: '法定通貨契約口座',
        Rechargeamount: '入金額',
        Youwillget: '受け取り額',
        network: 'ネットワーク',
        notsupportedAddress: '現在のアドレスはサポートされていません',
        selectaccount: 'アカウントを選択してください',
    },
    register: {
        title: '登録',
        send: '認証コード送信',
        Resend: '再送信',
        sendSuccess: '送信成功',
        PhoneNumber: '電話番号',
        Mailbox: 'メール',
        Captcha: '認証コード',
        Password: 'パスワード',
        ConfirmPassword: '確認パスワード',
        PromoteCode: 'プロモコード',
        OrgCode: '機関コード',
        btn: '登録',
        placeholder0: '電話番号を入力',
        placeholder1: 'パスワードを入力',
        placeholder2: '確認パスワードを入力',
        placeholder3: '推薦IDを入力',
        placeholder4: '認証コードを入力',
        placeholder5: 'メールを入力',
        emaiError: 'メール形式が正しくない',
        success: '登録成功',
        message: 'パスワードは6文字以上',
        message1: '確認パスワードは6文字以上',
        message2: 'パスワードが一致しない',
        searchCountryMsg: '国名、国番号で検索',
        haveAccount: 'アカウントをお持ちですか？',
        goLogin: 'ログイン',
        titleTips: '登録からスタート！',
        Invitationcode: '招待コード',
        Iagreewith: 'アカウント作成で',
        and: 'および',
    },
    safe: {
        SecuritySettings: 'セキュリティ設定',
        Accountsecurity: 'アカウントセキュリティ',
        phone: '電話',
        Notyetbound: '未連携',
        mailbox: 'メール',
        Loginpassword: 'ログインパスワード',
        Fundcode: '資金パスワード',
        Settings: '設定',
        Withdrawaladdressmanagement: '出金アドレス管理',
        Addwithdrawaladdress: '出金アドレス追加',
        Withdrawalcurrency: '出金通貨',
        Withdrawaladdress: '出金アドレス',
        WithdrawaladdressTips: '出金アドレスを入力',
        remark: '備考',
        confirm: '確認',
        Addedsuccessfully: '追加成功',
        Pleaseselectcurrency: '通貨を選択してください',
        Bindmailbox: 'メール連携',
        Bindmobilephone: '電話連携',
        ChangeLoginPassword: 'ログインパスワード変更',
        Setfundpassword: '資金パスワード設定',
        BindmailboxTips: '先にメールを連携してください',
        Addnewaddress: '新しいアドレス追加',
        Confirmdeleteaddress: 'この出金アドレスを削除しますか？',
    },
    share: {
        title: 'シェアして稼ぐ',
        commission: 'コミッション',
        Commissionrecord: 'コミッション履歴',
        Commissiontransferout: 'コミッション送金',
        Transferoutrecord: '送金履歴',
        Invitefriends: '友達招待',
        Invitationrecord: '招待履歴',
        Commissioncommission: 'コミッション率',
        ReferralCode: '紹介コード',
        Firstlevelmembers: '第1レベル会員',
        Secondlevelmembers: '第2レベル会員',
        Thirdlevelmembers: '第3レベル会員',
        Transferbalance: '残高へ送金',
        Confirmtransferout: '送金確認',
        Transfersuccessful: '送金成功',
        amount: '送金金額',
        Transferfiaaccount: '法定通貨アカウントへ送金',
    },
    trade: {
        high: '24h最高価格',
        low: '24h最低価格',
        vol: '24h取引量',
        buy: '買い',
        sell: '売り',
        buyBtn: '購入',
        sellBtn: '売却',
        Present: '成行注文',
        Limit: '指値注文',
        limitMsg: '価格',
        markPriceMsg: '現在の最適価格',
        num: '数量',
        zyzsSet: '利確・損切設定',
        zyPrice: '利確価格',
        zsPrice: '損切価格',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: '保有ポジション',
        Viewalltransactions: '全取引を表示',
        product: '商品',
        direction: '方向',
        Entrustedprice: '注文価格',
        Entrustednum: '注文数量',
        Latestprice: '最新価格',
        volume: '出来高',
        ChangeRatio: '変動率',
        buyBtnConfirm: '購入確認',
        sellBtnConfirm: '売却確認',
        totalAmount: '金額',
        Margin: '証拠金',
        balance: '利用可能',
        buyLimtMsg: '買いは市場価格以下のみ可',
        sellLimtMsg: '売りは市場価格以上のみ可',
        putNummsg: '数量を入力',
        putLimitPriceMsg: '指値を入力',
        pleaseAuth: '本人認証が必要',
        orderSuccess: '取引成功',
        Fullwarehouse: '全額',
        corkado: '買い可能',
        Kato: '買い',
        openable: '売り可能',
        Openempty: '売り',
        purchasable: '購入可能',
        vendibility: '売却可能',
        Orderconfirmation: '注文確認',
        Averageopeningprice: '平均建値',
        Marketprice: '市場価格',
        Openingquantity: '建玉数量',
        Stoplossprice: '損切価格',
        stopSurplusPrice: '利確価格',
        Averageprice: '平均価格',
        buyLimtMsg2: '買いは市場価格以下のみ可',
        sellLimtMsg2: '売りは市場価格以上のみ可',
        authTips: '本人認証が必要',
        profundity: '深度',
        deal: '取引',
        contract: '契約',
        TradeNow: '今すぐ取引',
        CloseTime: '休市',
        buyUp: '買い上げ',
        buyDown: '買い下げ',
        selectSeconds: '満期時間を選択',
        buyNums: '購入金額',
        minbuyNums: '最低購入',
        incomeRates: '収益率',
        buySuccessTips: '購入成功',
        secondNums: '秒',
        simulatedTrading: 'シミュレーション取引',
    },
    upPassword: {
        title: 'パスワード変更',
        oldPassword: '旧パスワード',
        oldPasswordMsg: '旧パスワードを入力',
        newPassword: '新パスワード',
        newPasswordMsg: '新パスワードを入力',
        twoPassword: '確認パスワード',
        twoPasswordMsg: '確認パスワードを入力',
        twoinputMsg: 'パスワードが一致しません',
        passwordTypeMsg: 'パスワードは6桁の数字である必要があります',
        submsg: '変更成功',
        btn: '変更確認',
    },
    user: {
        Avatarchange: 'アバター変更',
        Replacesuccessfully: '変更成功',
        authenticated: '認証済み',
        Notcertifiedyet: '未認証',
        Invitefriends: '友達招待',
        Activecenter: 'イベントセンター',
        Identityauthentication: '本人認証',
        Completedverification: '認証完了',
        Tobeverified: '未認証',
        SecuritySettings: 'セキュリティ設定',
        Lang: '言語選択',
        changeTheme: 'テーマ変更',
        helpcenter: 'ヘルプセンター',
        Aboutus: '会社情報',
        out: 'ログアウト',
        outmsg: 'ログアウト確認',
        trustscore: '信用スコア',
    },
    welcome: {
        title1: '業界トップの流動性',
        tips1: '99%の注文が最高価格で約定',
        title2: '12年の信頼',
        tips2: 'いつでもどこでも安心取引',
        title3: 'VIP特典',
        tips3: 'VIPなら手数料割引',
        title4: '100,000USDTデモ取引',
        tips4: 'リスクなしで練習',
        bnt1: '登録で10USDT獲得',
        bnt2: 'ログイン',
    },
    with: {
        Withdrawcurrency: '出金',
        currencyofwithdrawal: '出金通貨',
        Withdrawaladdress: '出金アドレス',
        Addwithdrawaladdress: '出金アドレス追加',
        Withdrawalquantity: '出金数量',
        availablebalance: '利用可能残高',
        WithdrawaladdressTips: '出金アドレス未設定、設定しますか？',
        selectWithdrawaladdress: '出金アドレスを選択',
        Insufficientavailablebalance: '残高不足',
        Withdrawingfiatcurrency: '法定通貨出金',
        Withdrawaloffiatcurrency: '法定通貨出金',
        Currentbalance: '現在の残高',
        Currencyreceived: '受取通貨',
        WithdrawingfiatcurrencyTips: '200USD以上で即時出金',
        Withdrawalaccount: '出金口座',
        Fiatcontractaccount: '法定通貨アカウント',
        Withdrawalamount: '出金額',
        Youneedwithdrawmoney: '出金額',
        Youwillget: '受取額',
        Withdrawimmediately: '今すぐ出金',
        mixAmount: '最小出金額',
        subMsg: '送信成功、審査待ち',
    },
}